import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from '@/components/i18n'
import { firestorePlugin } from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import ImageUploader from 'vue-image-upload-resize'
import CKEditor from '@ckeditor/ckeditor5-vue';
import wysiwyg from "vue-wysiwyg";


Vue.config.productionTip = false

Vue.use(CKEditor)
Vue.use(wysiwyg, {});
Vue.use(ImageUploader)
Vue.use(firestorePlugin)

const firebaseConfig = {
  apiKey: "AIzaSyCtU8fUJBC5ZReqYAPBToaSDUtznOD9Pwk",
  authDomain: "gracemed-bd7b3.firebaseapp.com",
  databaseURL: "https://gracemed-bd7b3.firebaseio.com",
  projectId: "gracemed-bd7b3",
  storageBucket: "gracemed-bd7b3.appspot.com",
  messagingSenderId: "630024693646",
  appId: "1:630024693646:web:08e63a42087d6767"
};
firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore()
export const auth = firebase.auth()

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
